import { useTranslation } from "react-i18next";
import { ArchiveDateStartingPoint as StartingPoint } from "../../../entities/IDocumentCategory";

export const ArchiveDateStartingPoint = ({ startingPoint }: { startingPoint: StartingPoint }) => {
  const { t } = useTranslation();
  return t("DOCUMENT_CATEGORY." + startingPoint);
};
